import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import { StudentProgress } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import { StoreTypename } from 'types';
import GET_STUDENT_PROGRESS from '../../queries/reports/get-student-progress-query';

export type StudentProgressState = {
  progressData?: StudentProgress[];
  error: ApolloError | undefined;
  isLoading: boolean;
  refetch: () => void;
};

export type StudentProgressFilter = {
  studentId: number | number[];
  classroomId: number | number[];
};

export type StudentProgressStoreDispatch = undefined;
export type StudentProgressStore = [StudentProgressState, StudentProgressStoreDispatch];

export const getDefaultStudentProgressState = (): { __typename: string } => ({
  __typename: StoreTypename.STUDENT_PROGRESS,
});

const useStudentProgressReportStore = (filter: StudentProgressFilter): StudentProgressStore => {
  const { data, loading, error, refetch }: QueryResult<{ studentProgress: StudentProgress[] }> =
    useQuery(GET_STUDENT_PROGRESS, {
      fetchPolicy: 'no-cache',
      variables: { where: filter },
    });

  return [
    {
      progressData: data?.studentProgress,
      error,
      isLoading: loading,
      refetch,
    },
    undefined,
  ];
};

export default useStudentProgressReportStore;
